<template>
  <div ref="htmlContent" v-html="privacyPolicy"></div>
</template>

<script>

import axios from "axios";

export default {
  name: 'Privacy',
  data() {
    return {
      privacyPolicy: ''
    }
  },
  async mounted() {
    // 通过CDN获取到隐私协议的内容
    try {
      // const response = await axios.get(`https://cotti-common-test.obs.ap-southeast-3.myhuaweicloud.com/privacy.html?v=${new Date().getTime()}`); // 获取协议内容
      const response = await axios.get(`https://cdn-product-prod.cotticoffee.com/cottiCoffee-api/privacy/cotti_service.html?v=${new Date().getTime()}`);
      this.privacyPolicy = response.data;
    } catch (error) {
      console.error('加载隐私协议失败:', error);
    }
  },
  updated() {
    const container = this.$refs.htmlContent
    if (!container) return
    const scripts = container.querySelectorAll('script')
    scripts.forEach(script => {
      const newScript = document.createElement('script')
      newScript.text = script.text
      document.body.appendChild(newScript); // 执行 script
      document.body.removeChild(newScript); // 执行后删除，避免污染
    })
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.scroll-hide {
  width: 100%;
  height: 100vh;
  -webkit-overflow-scrolling: touch;
  overflow-scrolling: touch;
  overflow-y: scroll;
  position: fixed;
  position: -ms-device-fixed;
  top: 0px; left: 0px; right: 0px; bottom: 0px;
}
.privacy{
  padding: 32px;
  font-size: 24px;
  line-height: 40px;
  word-break: break-all;
  background: #F5F5F5;
  .bold{
    font-weight: bold !important;
    .child-herf {
      color: #346EF4;
    }
  }
  .trilateral-herf {
      color: #346EF4;
      font-weight: bold !important;
    }
  .title{
    font-size: 32px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 32px;
  }
  .header{
    font-weight: 500;
    color: #3A3B3C;
    border-bottom: 1px solid #eee;
    margin-bottom: 32px;
    line-height: 40px;
    .version{
       margin-bottom: 12px;
    }
    .updateTime{
       margin-bottom: 12px;
    }
    .effectiveTime{
       margin-bottom: 40px;
    }
  }
  .content{
    font-size: 24px;
    color: #3A3B3C;
    line-height: 48px;
    .section{
      margin: 24px 0 16px 0;
      line-height: 48px;
      font-size: 28px;
      font-weight: 500;
    }
    .text{
      font-size: 24px;
      font-weight: 400;
    }
  }
}
</style>
